import { client } from '@up2stay/up2promo-api-client';
import { useEffect, useState } from 'react';

export type AuthPublicConfig = {
  registrationEnabled: boolean;
  walletEnabled: boolean;
};

/**
 * Public auth flags (no session). Registration defaults to enabled if the
 * request fails so the sign-up form still appears; submit then maps
 * `registrationsDisabled`. Wallet stays off until the API confirms signing
 * is configured.
 */
export function useAuthPublicConfig(): {
  registrationEnabled: boolean | undefined;
  walletEnabled: boolean;
} {
  const [registrationEnabled, setRegistrationEnabled] = useState<
    boolean | undefined
  >(undefined);
  const [walletEnabled, setWalletEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void client
      .get({ url: '/api/v1/auth/public-config', responseType: 'json' })
      .then((res) => {
        if (cancelled) return;
        const data = res.data as AuthPublicConfig | undefined;
        setRegistrationEnabled(data?.registrationEnabled !== false);
        setWalletEnabled(data?.walletEnabled === true);
      })
      .catch(() => {
        if (!cancelled) {
          setRegistrationEnabled(true);
          setWalletEnabled(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { registrationEnabled, walletEnabled };
}
